import {isNil} from 'ramda';

import {Nullish} from 'shared/web';

import {ApiEnumItem} from '../../../types/ApiEnum';
import {getBodyStyleCategory} from '../../../utils/getBodyStyleCategory';
import {VehicleCategoryFilter} from '../types/VehicleCategoryFilter';

export type BodyTypeOptionGroup = {
  category: VehicleCategoryFilter;
  label: string;
  options: ApiEnumItem[];
};

type BodyTypeGroupLabels = Record<VehicleCategoryFilter, string>;

/**
 * Splits the `car_style` enum into one group per vehicle category and drops groups
 * that do not match the selected category. Keys of an unknown category are ignored.
 * Returns groups in a fixed order (cars first) and omits empty groups.
 */
export function getBodyTypeOptions(
  bodyStyles: ApiEnumItem[],
  vehicleCategory: VehicleCategoryFilter | Nullish,
  labels: BodyTypeGroupLabels
): BodyTypeOptionGroup[] {
  return [VehicleCategoryFilter.CAR, VehicleCategoryFilter.VAN]
    .filter((category) => isNil(vehicleCategory) || category === vehicleCategory)
    .map((category) => ({
      category,
      label: labels[category],
      options: bodyStyles.filter((item) => getBodyStyleCategory(item.key) === category),
    }))
    .filter((group) => group.options.length > 0);
}
